// extracted by css-extract-rspack-plugin
export default {"second_drawer":"second_drawer-MGHa9h","secondDrawer":"second_drawer-MGHa9h"};